import { IPrintFileModification } from "../common-interfaces/print-file";

/**
 * Builds the border modification code used inside a SKU, e.g. 35 -> "B35W".
 *
 * getPrintFileModificationFromCode reads the width as exactly two characters,
 * so the width is zero padded and only 1-99 mm can be expressed.
 */
export const getBorderModificationCode = (widthMm: number, color: 'W' | 'B' = 'W') => {
    let width = Math.round(widthMm);

    if (!(width > 0) || width > 99)
        return null;

    return `B${String(width).padStart(2, '0')}${color}`;
};

export const getPrintFileModificationFromCode = async (code: string): Promise<IPrintFileModification> => {


    // Border, example: B35W
    if (code.startsWith('B')) {
        let borderWidthMm = parseInt(code.substring(1, 3));
        let colorCode = code.substring(3);
        let color = '#ffffff';
        switch (colorCode) {
            case 'W':
                color = '#ffffff';
                break;
            case 'B':
                color = '#000000';
                break;
        }
        return {
            type: 'BORDER',
            code: code,
            borderColor: color,
            borderWidthMm: borderWidthMm
        }
    }


    // Greyscale, example: GREYSCALE
    if (code == 'GREYSCALE') {
        return {
            type: 'GREYSCALE',
            code: code
        }
    }

    // Paper type, example: PAPERSILK
    if (code == 'PAPERSILK') {
        return {
            type: 'PAPER_TYPE',
            code: code,
            paperType: 'SILK'
        }
    }

    // Unrecognised code - callers already skip a null modification.
    return null;
}